export interface ITimelineEvent {
  id: string;
  timestamp: number;
  type: TEventType;
  title: string;
  description: string;
  severity?: TSeverityLevel;
  isError?: boolean;
  isBookmarked?: boolean;
  suggestion?: string;
  stateChanges?: IStateChange[];
  clientId?: string;
  data?: any;
  // 메모리 최적화를 위한 필드들
  memorySize?: number; // 추정 메모리 사용량 (bytes)
  isCompressed?: boolean; // 데이터가 압축되었는지
  originalDataSize?: number; // 원본 데이터 크기
}

export type TEventType = 
  | 'action' 
  | 'state_change' 
  | 'error' 
  | 'api_call' 
  | 'connection' 
  | 'user_action'  // USER_ACTION의 변환 타입
  | 'navigation'   // NAVIGATION의 변환 타입
  | 'component'    // 컴포넌트 관련 이벤트
  | 'network'      // 네트워크 관련 이벤트
  | 'performance'  // 성능 관련 이벤트 (PERFORMANCE 변환)
  | 'click'        // 클릭 이벤트 (세분화)
  | 'input'        // 입력 이벤트 (세분화)
  | 'lifecycle'    // 컴포넌트 라이프사이클
  // 백워드 호환성을 위한 대문자 타입들
  | 'API_CALL'
  | 'STATE_CHANGE'
  | 'USER_ACTION';

export type TSeverityLevel = 'critical' | 'warning' | 'info';

export interface IStateChange {
  key: string;
  before: any;
  after: any;
}

// 메모리 관리 관련 상수
export const MEMORY_CONSTANTS = {
  MAX_EVENTS: 1000,
  BATCH_SIZE: 50,
  MAX_OBJECT_SIZE: 100 * 1024, // 100KB
  CLEANUP_THRESHOLD: 900, // 900개 이벤트에서 정리 시작
  COMPRESSION_THRESHOLD: 1024, // 1KB 이상일 때 압축 고려
} as const;

// 메모리 사용량 추적을 위한 인터페이스
export interface IMemoryStats {
  totalEvents: number;
  totalMemoryUsage: number; // bytes
  compressedEvents: number;
  lastCleanupTime: number;
  averageEventSize: number;
}
